export const DefaultMapZoom = {
  s: 10,
  m: 12,
  l: 13,
  xl: 14,
};

export const MarkerZIndex = {
  minimized: 1,
  default: 9999,
  selected: 99999,
} as const;

export const WebMapControlProps = {
  disableDefaultUI: true,
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  rotateControl: false,
} as const;
